export { default, default as Kutt } from "#src/Kutt";
export { type ConfigI } from "#src/config";
export * from "#src/api/index";
